import React from 'react';
import { Icon } from '@udemy/icons';
export const UnwishlistedIcon = props => /*#__PURE__*/React.createElement(Icon, Object.assign({
  glyph: "wishlisted-outline",
  label: false
}, props));
UnwishlistedIcon.$$udType = 'Icon';
export const WishlistedIcon = props => /*#__PURE__*/React.createElement(Icon, Object.assign({
  glyph: "wishlisted",
  label: false
}, props));
WishlistedIcon.$$udType = 'Icon';
//# sourceMappingURL=unwishlisted-icon.react-component.js.map